<template>
    <div>
        <v-card>
            <v-card-title v-html="header">
            </v-card-title>

            <v-card-text :class="$style.vCard">
                <v-form v-model="valid_form" ref="form">
                    <div :class="$style.questions" v-html="body"/>
                    <div v-html="subtext" />

                    <v-container fluid>
                        <v-layout row wrap v-for="group in question.config.groups" :key="`group_${group.id}`">
                            <v-flex xs6 md5>
                                <div v-html="group.label[$language()]"></div>
                                <div :class="['available_options_wrapper', 'mt-8']">
                                    <h3 align='center'>
                                        <str :index="'survey > question > ranking > available_options'" />
                                    </h3>
                                    <template v-for="(input, index) in ranking.source[group.id]">
                                        <v-container :key="'ranking_item_'+group.id+'_'+input.id" py-0>
                                            <v-layout row wrap fill-height>
                                                <v-flex xs2 md1>
                                                    <div
                                                        :class="$style.alphabeticalOrderWrapper">
                                                        <div :class="[$style.alphabeticalOrder, 
                                                                {[$style.alphabeticalOrderExisted]: checkRankedAnswerExisted(group.id, input)}]">
                                                            {{alphabeticOrder[index]}}
                                                        </div>
                                                    </div>
                                                </v-flex>
                                                <v-flex xs10 md11>
                                                    <div 
                                                        v-if="!input.other" 
                                                        :class="[$style.list_item, 
                                                                {[$style.list_item_existed]: checkRankedAnswerExisted(group.id, input)},
                                                                {[$style.list_item_max]: checkRankedAnswerMax(group)}]" 
                                                        @click="addRankedAnswer(group, input)">
                                                        <span v-if="survey.mode=='dev' || survey.mode=='test'"
                                                            :class="$style.debug">[{{input.value}}]</span>
                                                        <div v-html="input.label[$language()]" :class="$style.rankingSelections"></div>
                                                    </div>

                                                    <div v-else-if="other[group.id][input.id]!=null && other[group.id][input.id].length>0"
                                                        :class="$style.list_item" :key="'ranking_item_'+group.id+'_'+input.id">
                                                        {{ other[group.id][input.id] }}
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </template>
                                </div>    
                            </v-flex>
                            <v-flex xs2 class="hidden-sm-and-down">
                                <div :class="[$style.arrowSectionWrapper, 'mt-10']">
                                    <div :class="$style.arrowTopSection">
                                    </div>
                                    <div :class="$style.arrowIconSection">
                                        <v-icon color="#cecdce">
                                            fas fa-chevron-right
                                        </v-icon>
                                    </div>
                                    <div :class="$style.arrowTopSection">
                                    </div>
                                </div>
                            </v-flex>
                            <v-flex xs6 md5> 
                                <div v-html="group.label[$language()]"></div>
                                <div :class="$style.selectionOptionsLabelWrapper">
                                    <div :class="$style.selectionOptionsLabelInnerWrapper">
                                        <v-icon x-small color="#d0eaee">
                                            fas fa-circle
                                        </v-icon>
                                        <span class='ml-2'>
                                            <str index="survey > question > ranking > required" />
                                        </span>
                                    </div>

                                    <div :class="$style.selectionOptionsLabelInnerWrapper">
                                        <v-icon x-small color="#dedede">
                                            fas fa-circle
                                        </v-icon>
                                        <span class='ml-2'>
                                            <str index="survey > question > ranking > optional" />
                                        </span>
                                    </div>
                                </div>
                                <div :class="['selection_options_wrapper', 'mt-2']">
                                    <h3 align='center'>
                                        <str :index="'survey > question > ranking > selected'" />
                                    </h3>
                                </div>
                                <template v-for="(n, index) in parseInt(group.type_config.Ranking.max)">
                                    <v-container :key="'ranking_item_'+group.id+'_'+n" py-0> 
                                        <v-layout row wrap fill-height>
                                            <v-flex xs2 md1>
                                                <div :class="$style.alphabeticalOrderWrapper">
                                                    <div :class="[$style.alphabeticalOrderAnswer,
                                                                {[$style.alphabeticalOrderAnswerRequiredNonExisted]: !checkSelectedRankedAnswer(group.id, index) && index < parseInt(group.type_config.Ranking.min)},
                                                                {[$style.alphabeticalOrderAnswerOptionalNonExisted]: !checkSelectedRankedAnswer(group.id, index) && index >= parseInt(group.type_config.Ranking.min)},
                                                                {[$style.alphabeticalOrderAnswerExisted]: checkSelectedRankedAnswer(group.id, index)}]">
                                                        {{index + 1}}
                                                    </div>
                                                </div>
                                            </v-flex>
                                            <v-flex xs10 md11>
                                                <div :class="[$style.answer_item, 
                                                            {[$style.answer_item_required_non_existed]: !checkSelectedRankedAnswer(group.id, index) && index < parseInt(group.type_config.Ranking.min)},
                                                            {[$style.answer_item_optional_non_existed]: !checkSelectedRankedAnswer(group.id, index) && index >= parseInt(group.type_config.Ranking.min)},
                                                            {[$style.answer_item_existed]: checkSelectedRankedAnswer(group.id, index)}]"
                                                    @click="removeRankedAnswer(group, index)">
                                                    <template v-if="ranking.ranked[group.id][index]">
                                                        <template v-if="!ranking.ranked[group.id][index].other">
                                                            <div v-html="ranking.ranked[group.id][index].label[$language()]" :class="$style.rankingSelections"></div>
                                                        </template>

                                                        <template v-else>
                                                            {{ other[group.id][input.id] }}
                                                        </template>
                                                    </template>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </template>
                            </v-flex>
                            <v-flex xs12 style="text-align: center:" class='mt-10'>
                                <center>
                                    <completionBar
                                        :total="question.value!=null && question.value[group.id] ? Math.round((question.value[group.id].length/parseInt(group.type_config.Ranking.min,10))*100) : 0"
                                        :disabled-overflow="true"
                                        :displayNumber="true" />
                                </center>
                            </v-flex>
                            <v-flex xs12 style="text-align: right;">
                                <v-btn 
                                    color='#009dad' 
                                    rounded 
                                    dark
                                    depressed
                                    @click="ranking.ranked[group.id] = [];">
                                    RESET
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-card-text v-html="footer">
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import draggable from "vuedraggable";
    import completionBar from "../assets/completionBar.vue";

    const controller = require("./controllers/ranking.js").default;
    const module_generator = require("./controllers/module_generator.js").default;

    var module_config = module_generator('ranking-question', controller);

    module_config.components = {
        draggable,
        completionBar
    }

    module_config.methods.addRankedAnswer = function(group, input) {
        if ((this.ranking.ranked[group.id].filter(function(element) {
                    return element.id === input.id
        }).length == 0) && (this.ranking.ranked[group.id].length < parseInt(group.type_config.Ranking.max))) {
            this.ranking.ranked[group.id].push(input);
        }
    }

    module_config.methods.removeRankedAnswer = function(group, index) {
        if(this.ranking.ranked[group.id].length > 0 && this.ranking.ranked[group.id][index]) {
            this.ranking.ranked[group.id].splice(index, 1);
        }
    }

    module_config.methods.checkRankedAnswerExisted = function(group_id, input) {
        if (this.ranking.ranked[group_id].filter(function(element) {
            return element.id === input.id
        }).length > 0) {
            return true
        }
        return false;
    }

    module_config.methods.checkRankedAnswerMax = function(group) {
        return this.ranking.ranked[group.id].length >= parseInt(group.type_config.Ranking.max)
    }

    module_config.methods.checkSelectedRankedAnswer = function(group_id, index) {
        if(this.ranking.ranked[group_id][index]) {
            return true;
        }
        return false;
    }

    module_config.computed.ranked = function () {
        return this.ranking ? this.ranking.ranked : null;
    }
    module_config.computed.alphabeticOrder = function() {
        var alphabets = [];
        var start = 'a'.charCodeAt(0);
        var last  = 'z'.charCodeAt(0);
        for (var i = start; i <= last; ++i) {
            alphabets.push(String.fromCharCode(i));
        }

        return alphabets.join('');
    }
    module_config.watch.ranked = {
        deep: true,
        handler: function (after, before) {
            var value = {};
            for (let g in after) {
                var inputs = after[g];
                value[g] = [];

                for (let i = 0; i < inputs.length; i++) {
                    var input = inputs[i];
                    value[g].push(input.value);
                }
            }
            this.value = value;
        }
    }

    export default module_config;
</script>

<style module>
    .vCard {
        padding: 19px 140px;
        width: 100%;
        margin-bottom: 20px;
    }

    .question {
        border: 1px solid slategray;
        border-radius: 3px;
        margin: 25px;
        padding: 15px;
    }

    .questions {
        font-size: 18px;
        margin: 0px 0px 20px;
        color: black;
    }

    .list_item {
        border: 1px solid #5d6771;
        border-radius: 3px;
        margin: 10px 10px 10px 0;
        padding: 2px 15px;
        cursor: pointer;
        background: #5d6771;
        color: white;
        box-shadow: 2px 1px 3px 0px #c0c0c0;
    }

    .list_item:hover {
        background-color: #778491;
    }

    .locked {
        border-color: whitesmoke;
        color: lightgrey;
    }

    .complete {
        border-color: #0588EF;
        border-width: 3px;
        color: #0588EF;
        font-weight: bold;
    }

    .debug {
        display: inline-block;
        margin: 5px;
        color: darkred;
    }

    .alphabeticalOrderWrapper {
        display: flex; 
        align-items: center; 
        justify-content: center; 
        height: 100%;
    }

    .alphabeticalOrder {
        display: flex; 
        align-items: center; 
        justify-content: center; 
        background-color: #5d6771; 
        color: white; 
        border-radius: 50%; 
        width: 25px; 
        height: 25px;
    }

    .alphabeticalOrderExisted {
        background-color: #b5b4b6;
        color: #b5b4b6
    }

    .list_item_existed {
        background-color: #b5b4b6;
        color: #b5b4b6;
        cursor: initial;
        pointer-events: none;
        border: 1px solid #b5b4b6;
        -webkit-user-select: none; /* Chrome/Safari */        
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE10+ */
        -o-user-select: none;
        user-select: none;
    }

    .list_item_max {
        pointer-events: none;
        -webkit-user-select: none; /* Chrome/Safari */        
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE10+ */
        -o-user-select: none;
        user-select: none;
    }

    .alphabeticalOrderAnswer {
        display: flex; 
        align-items: center; 
        justify-content: center; 
        background-color: #b5b4b6; 
        color: #b5b4b6; 
        border-radius: 50%; 
        width: 25px; 
        height: 25px;
    }

    .alphabeticalOrderAnswerRequiredNonExisted,.answer_item_required_non_existed {
        background-color: #d0eaee !important;
        color: white;
    }

    .alphabeticalOrderAnswerOptionalNonExisted, .answer_item_optional_non_existed {
        background-color: #dedede !important;;
        color: white;
    }

    .alphabeticalOrderAnswerExisted {
        background-color: #5d6771; 
        color: white; 
    }

    .answer_item {
        background-color: #b5b4b6;
        color: #b5b4b6;
        cursor: initial;
        pointer-events: none;
        border: 1px solid #b5b4b6;
        -webkit-user-select: none; /* Chrome/Safari */        
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE10+ */
        -o-user-select: none;
        user-select: none;
        border-radius: 3px;
        margin: 10px 10px 10px 0;
        padding: 2px 15px;
        box-shadow: 2px 1px 3px 0px #c0c0c0;
        height: 28px;
    }

    .answer_item_existed {
        background-color: #5d6771;
        color: white;
        cursor: pointer;
        pointer-events: initial;
        border: 1px solid #5d6771;
    }

    .arrowSectionWrapper {
        height: 100%; 
        display: flex; 
        flex-direction: column; 
        align-items: center; 
        justify-content: center;
    }

    .arrowTopSection {
        border: 1px dashed #cecdce; 
        height: 35%; 
        width: 0%;
    }

    .arrowIconSection {
        border-radius: 50%; 
        border: 1px dashed #cecdce; 
        width: 45px; 
        height: 45px; 
        display: flex; 
        align-items: center; 
        justify-content: center;
    }

    .rankingInputLabel p{
        margin-bottom: 0px !important;
    }
    
    .rankingSelections p {
        margin-bottom: 0px !important;
    }

    .selectionOptionsLabelWrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
    }

    .selectionOptionsLabelInnerWrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin: 0 10px;
    }

    @media only screen and (max-width: 1240px) {
        .vCard {
            padding: 0 100px;
        }
    }

    @media only screen and (max-width: 1145px) {
        .vCard {
            padding: 0 80px;
        }
    }

    @media only screen and (max-width: 1105px) {
        .vCard {
            padding: 0 30px;
        }
    }

    @media only screen and (max-width: 1000px) {
        .vCard {
            padding: 0 10px;
        }
    }

    @media only screen and (max-width: 980px) {

        .vCard {
            margin: 0px !important;
            width: 100%;
            padding: 0px 10px;
        }

        .questions {
            width: 95%;
            margin: 0px !important;
        }

    }
</style>

<style>
    .otherInput .v-text-field {
        border: 1px solid #ffffff;
        border-radius: 3px;
        margin: 0px 10px;
        padding: 15px 15px 0px;
        background: #ffffff;
        box-shadow: 2px 1px 3px 0px #c0c0c0;
    }
</style>